
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Notes on installing alternative OSes on Chromebooks";
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Tested on Dell Chromebook 3100, with MrChromebox's RW_LEGACY flashed via SH1MMER. Proxying on the edge part 2 eta son, just need to get to writing it."
    }), "\n", _jsx(_components.h2, {
      children: "Windows 11"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Used tiny11 b1 iso"
      }), "\n", _jsx(_components.li, {
        children: "Got to winPE, trackpad did not work. USB mouse did though."
      }), "\n", _jsx(_components.li, {
        children: "Couldn't start installation, complained about missing disk drivers"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Windows 10"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Worked fine, needed to install EC drivers from CoolStar."
      }), "\n", _jsx(_components.li, {
        children: "Make sure to use a dedicated Windows USB installer such as WoeUSB on Linux."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Fedora 38 Workstation"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Booted and installed fine"
      }), "\n", _jsx(_components.li, {
        children: "All devices seem to work well (trackpad, kb, wifi, bt)"
      }), "\n", _jsx(_components.li, {
        children: "Best to install to stateful partition. Storage size is good enough™, also allows you to go back to crOS via recovery usb."
      }), "\n", _jsx(_components.li, {
        children: "Stable enough to daily drive"
      }), "\n"]
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	